import React, { useEffect, useState } from "react";
import LOCAL_KEYS, {
  parseLocalStorageJSON,
} from "../../../helpers/Localstorage";
import { Link } from "react-router-dom";
import {
  Groups2Outlined,
  Business,
  AssignmentOutlined,
  AccessTime,
  RequestQuoteOutlined,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { requestEmpDashboardList } from "../../../Redux/DashboardState/dashBoardActionCreator";
import CustomDataTable from "../../../components/CustomDataTable";
import CustomToolTip from "../../../components/ToolTip";
import moment from "moment";
import { MdEdit } from "react-icons/md";
import {
  requestEditTimesheets,
  requestGetTimesheetById,
  setResetEditTimesheets,
  setResetGetTimesheetById,
  setResetStateTimesheetById,
} from "../../../Redux/TimeSheetState/TimeSheetActionCreator";
import TimeSheet from "../../Employee/TimeSheet";
import { toast } from "react-toastify";
import { requestProjectsById } from "../../../Redux/ProjectState/ProjectActionCreator";
import { use } from "react";

function UserLandingPage() {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState({ title: "", isOpen: false });

  const userDetails = parseLocalStorageJSON(LOCAL_KEYS.USER_DETAILS);
  const empDashboardList = useSelector(
    (state) => state.EmpDashboardListReducer
  );
  const TimeSheets = useSelector(
    (state) => state.TimeSheetByProjectIdReducerForUserPage
  );
  const timesheetByIdReducer = useSelector(
    (state) => state.GetTimesheetByIdReducer
  );
  const projectsList = useSelector((state) => state.ProjectsByIdReducer);
    const editTimesheetReducer = useSelector(
      (state) => state.EditTimesheetsReducer
    );

  const columns = [
    {
      name: "Project Id",
      selector: (row) => row.projectId,
      sortable: true,
      // hide: "sm",
    },
    {
      name: "Start Date",
      selector: (row) => moment(row.startDate).format("MM-DD-YYYY"),
      sortable: true,
    },
    {
      name: "End Date",
      selector: (row) => moment(row.endDate).format("MM-DD-YYYY"),
      sortable: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
      sortable: true,
      hide: "sm",
    },
    // {
    //   name: "Total Hours",
    //   selector: (row) => row.total_hours,
    //   sortable: true,
    //   hide: "sm",
    // },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          <div className="lg:hidden">
            {row.status === "APP" && (
              <span className="text-green-500 text-[12px]">Approved</span>
            )}
            {row.status === "REJ" && (
              <span className="text-red-500 text-[12px]">Rejected</span>
            )}
            {row.status === "SUB" && (
              <span className="text-yellow-500 text-[10px]">Submitted</span>
            )}
          </div>
          <button
            onClick={() => handleEdit(row)}
            className={
              "text-primary hover:text-primaryDark disabled:cursor-not-allowed"
            }
          >
            <MdEdit size={24} />
          </button>
        </div>
      ),
    },
  ];

  const cards = [
    {
      title: "Rejected Timesheets",
      // count: countList?.response?.EmployeesList?.Employees,
      // activeEmployees: countList?.response?.EmployeesList?.ActiveEmployees,
      // inactiveEmployees: countList?.response?.EmployeesList?.InactiveEmployees,
      count: empDashboardList?.response?.RejectedTimesheets,
      icon: (
        <Groups2Outlined
          fontSize={"large"}
          className="w-20 h-20  text-primary"
        />
      ),
      isUsersCard: true,
      // link: "/emptimesheets",
    },
  ];

  const handleEdit = (row) => {
    dispatch(setResetGetTimesheetById());
    setIsModalOpen({ title: "", isOpen: false });
    let isProjectEnded = row?.endDate && moment().isAfter(moment(row?.endDate));
    dispatch(requestGetTimesheetById(row.id));
    setIsModalOpen({ title: "Edit TimeSheet", isOpen: true });
  };

  const handleAddTimeSheet = (values, selectedFile) => {
    const editTimeSheetPayload = {
      // projectId: values.projectId,
      work_location: values.work_location,
      startDate: values.startDate,
      endDate: values.endDate,
      total_hours: values.total_hours,
      holidays: values.holidays,
      // remarks: values.rejectionRemarks || null,
    };
    dispatch(
      requestEditTimesheets({
        id: timesheetByIdReducer?.Response?.id,
        // data: values,
        timeSheet: JSON.stringify(editTimeSheetPayload), // Stringify the data here
        files: selectedFile || "null",
      })
    );
  };
 useEffect(() => {
    if (!editTimesheetReducer?.Loading && editTimesheetReducer?.Response) {
      // setIsModalOpen({ title: "Edit Timesheet", isOpen: false });
      handleClose();
      dispatch(setResetEditTimesheets());
      dispatch(requestEmpDashboardList());
    } else if (!editTimesheetReducer?.Loading && editTimesheetReducer?.Error) { 
      toast.error("Error editing Timesheet data");
      dispatch(setResetEditTimesheets());
    }
  }, [editTimesheetReducer]);

  const handleClose = () => {
    setIsModalOpen({ title: "", isOpen: false });
    dispatch(setResetEditTimesheets());
    dispatch(setResetStateTimesheetById());
  };

  useEffect(() => {
    if (!timesheetByIdReducer?.Loading && timesheetByIdReducer?.Response) {
      setIsModalOpen({ title: "Edit Timesheet", isOpen: true });
    } else if (!timesheetByIdReducer?.Loading && timesheetByIdReducer?.Error) {
      toast.error("Error fetching Timesheet data");
      dispatch(setResetGetTimesheetById());
    }
  }, [timesheetByIdReducer]);

  useEffect(() => {
    dispatch(requestEmpDashboardList());
    dispatch(requestProjectsById());
  }, []);

  console.log("empDashboardList", timesheetByIdReducer);
  return (
    <div className="p-5 container-fluid h-[85vh] overflow-y-scroll">
      <h2 className="text-primary text-xl font-semibold mb-4">
        Hi {`${userDetails?.firstName || ""} ${userDetails?.lastName || ""}`},
        welcome to Employee Dashboard
      </h2>
      <p className="text-primary text-lg font-semibold mb-4">Rejected Timesheets</p>
      {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {cards.map((card, index) => (
          <div key={index} className="bg-white p-6 rounded-xl shadow-md">
            <div className="flex items-center gap-2">
              {card?.icon}
              <h3 className="text-lg font-semibold text-gray-800">
                {card?.title}
              </h3>
            </div>

            <div className="flex items-center justify-between mt-2">
              <p className="text-3xl font-bold text-gray-900">{card.count}</p>
            </div>
            <div className="mt-4">
              <Link
                to={card.link}
                className="text-sm text-primary hover:text-secondaryBlue"
              >
                View All
              </Link>
            </div>
          </div>
        ))}
      </div> */}
      <TimeSheet
        timesheetValues={timesheetByIdReducer?.Response}
        show={isModalOpen.isOpen}
        onClose={handleClose}
        title={isModalOpen.title}
        onAddTimeSheet={handleAddTimeSheet}
        projectsList={projectsList?.response || []}
        minDate={TimeSheets?.initialValues.startDate} // Pass Min Date
        maxDate={TimeSheets?.initialValues.endDate}
      />
      <div>
        <CustomDataTable
          columns={columns}
          data={empDashboardList?.response?.rejectedTimesheets || []}
          // enableSearch={false}
          // serverPagenation
          paginationTotalRows={
            empDashboardList?.response?.rejectedTimesheets?.totalElements
          }
          // handleChangePage={handlePageChange}
          // handleRowsChange={handleRowsChange}
          // conditionalRowStyles={conditionalRowStyles}
          // onSelectedRowsChange={handleCheckboxChange}
          // selectableRows={true}
          // selectableRowDisabled={rowDisabledCriteria}
          fixedHeaderScrollHeight={"62vh"}
        />
      </div>
    </div>
  );
}

export default UserLandingPage;
